import React, { useContext, useState } from 'react';
import { AuthContext } from '../../../../shared/context/auth-context'
import NomItem from './nomItem';
import ShareModal from '../../../../shared/components/UIElements/shareModal'
import AddBook from '../pages/addBook';

import './nomLists.css';


const NomLists = (props) => {
  // const { user } = useContext(AuthContext);
  const auth = useContext(AuthContext)

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);



  return (
    <main>
    
        <div className='addBook-model-opener'>
        {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && (    
          <button onClick={handleOpen}>Add New Book</button>
        )} 
        <ShareModal show={open} onCancel={handleClose}>
          <AddBook/>
        </ShareModal>
      </div>
  
      
      
      
      <table id='books'>
        <thead>
          <tr>
            <th>№</th>
            <th>Судрын нэр</th>
            <th>Төрөл</th>
            <th>Тайлбар</th>
            <th>Үнэ:</th>
            {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && (
              <th>Delete/Edit</th>
            )}
            
          </tr>    
        </thead>
        
        <tbody>
          {props.book.map((book, i) => (
            <NomItem 
              key={i}
              num={i + 1}
              id={book.id}
              title={book.title}
              type={book.type}
              description={book.description}
              price={book.price}       
            />       
          ))}   
        </tbody>
      </table>  
    </main> 
  )
}

export default NomLists;